export const CONFIG = {
  intervalUpdateState: 5000,
  intervalUpdateAfterSendCommand: 1000,
  demoUsername: 'demo',
  demoPassword: 'password1',
  objectTypes: [
    'Moto',
    'Car',
    'SUV',
    'QuadBike'
  ],
  dayLabels: { su: 'Вс', mo: 'Пн', tu: 'Вт', we: 'Ср', th: 'Чт', fr: 'Пт', sa: 'Сб' },
  monthLabels: { 1: 'Янв', 2: 'Фев', 3: 'Мар', 4: 'Апр', 5: 'Май', 6: 'Июнь', 7: 'Июль', 8: 'Авг', 9: 'Сен', 10: 'Окт', 11: 'Ноя', 12: 'Дек' },
  commandIcon: {
    '1': { iconName: 'flat_17' }, // Позвонить на автомобиль
    '2': { iconName: 'flat_6' }, // Поиск на парковке
    '3': { iconName: 'flat_4' }, // Статус
    '4': { iconName: 'flat_1' }, // Запрос местоположения
    '5': { iconName: 'flat_7' }, // Запрос баланса
    '6': { iconName: 'flat_9' }, // Сброс
    '7': { iconName: 'default' }, // Продление связи
    '8': { iconName: 'default' }, // Завершение связи
    '9': { iconName: 'default' }, // Команда CHECK
    '10': { iconName: 'flat_21' }, // Режим антиограбления вкл
    '11': { iconName: 'flat_22' }, // Режим антиограбления выкл
    '12': { iconName: '3' }, // Включить сигнал
    '13': { iconName: 'default' }, // Паника
    // Двигатель
    '101': { iconName: 'flat_3' }, // Запустить двигатель
    '102': { iconName: 'flat_3--off' }, // Остановить двигатель
    '103': { iconName: 'flat_15' }, // Включить подогреватель
    '104': { iconName: 'flat_15--off' }, // Выключить подогреватель
    '105': { iconName: 'flat_13' }, // Заблокировать двигатель
    // Охрана
    '201': { iconName: 'flat_20' }, // Включить охрану
    '202': { iconName: 'flat_19' }, // Выключить охрану
    '203': { iconName: 'flat_on_security' }, // Включить активную охрану
    '204': { iconName: 'flat_off_security' }, // Выключить активную охрану
    '205': { iconName: 'ugona_30' }, // Снять режим охраны с багажника
    // ТО
    '301': { iconName: 'flat_2' }, // Включить режим ТО
    '302': { iconName: 'flat_2--off' }, // Выключить режим ТО
    // Контакты
    '401': { iconName: 'flat_20' }, // Открыть замок
    '402': { iconName: 'flat_19' }, // Закрыть замок
    '403': { iconName: '10' }, // Открыть багажник
    '404': { iconName: 'hand_1' }, // Включить свободные руки
    '405': { iconName: 'flat_3_cross' }, // Выключить свободные руки
    // Трекинг
    '501': { iconName: 'flat_5' }, // Включить трекинг
    '502': { iconName: 'flat_5--off' }, // Выключить трекинг
    // Остальное
    '601': { iconName: 'flat_internet_on' }, // Включить интернет
    '602': { iconName: 'flat_off_tracking' }, // Выключить интернет
    '603': { iconName: 'flat_ch' }, // Включить канал
    '604': { iconName: 'flat_ch_cross' }, // Выключить канал
    '605': { iconName: 'default' }, // Выключение датчика удара
    '606': { iconName: 'default' }, // Выключение датчика наклона
    '609': { iconName: 'default' }, // Выключение доп. датчика
    '612': { iconName: 'flat_11' }, // Импульс на канал
    '613': { iconName: 'flat_ch1' }, // Включить реле1
    '614': { iconName: 'flat_ch1_cross' }, // Выключить реле1
    '615': { iconName: 'flat_11' }, // Импульс на реле1
    '1002': { iconName: 'flat_A' }, // Режим А
    '1003': { iconName: 'flat_B' }, // Режим B
    'default': { iconName: 'default' },
  },
  periodTimer: [
    {
      text: 'Один раз',
      value: 'oneTime'
    },
    {
      text: 'Ежедневно',
      value: 'everyDay'
    },
    {
      text: 'Еженедельно',
      value: 'everyWeek'
    }
  ],
  periodTimerPandora: [
    {
      text: 'Ежедневно',
      value: 'everyDay'
    },
    {
      text: 'Еженедельно',
      value: 'everyWeek'
    }
  ],
  weekTimer: [
    {
      text: 'пн',
      value: 1
    },
    {
      text: 'вт',
      value: 2
    },
    {
      text: 'ср',
      value: 3
    },
    {
      text: 'чт',
      value: 4
    },
    {
      text: 'пт',
      value: 5
    },
    {
      text: 'сб',
      value: 6
    },
    {
      text: 'вс',
      value: 0
    }
  ],
  extra: {
    car: '<ObjectExtra xmlns="http://ugona-net.ru/agregator" xmlns:xsi="http://www.w3.org/2001/XMLSchema-instance" xsi:type="Transport"><Attributes xsi:type="Car"/></ObjectExtra>',
    moto: '<ObjectExtra xmlns="http://ugona-net.ru/agregator" xmlns:xsi="http://www.w3.org/2001/XMLSchema-instance" xsi:type="Transport"><Attributes xsi:type="Moto"/></ObjectExtra>',
    SUV:'<ObjectExtra xmlns="http://ugona-net.ru/agregator" xmlns:xsi="http://www.w3.org/2001/XMLSchema-instance" xsi:type="Transport"><Attributes xsi:type="SUV"/></ObjectExtra>',
    quadBike:'<ObjectExtra xmlns="http://ugona-net.ru/agregator" xmlns:xsi="http://www.w3.org/2001/XMLSchema-instance" xsi:type="Transport"><Attributes xsi:type="QuadBike"/></ObjectExtra>',

  },
  orderStatus:{
    created:"В обработке",
    paid:"Оплачено",
    completed:"Завершено",
    canceled:"Отменено", 
    error:"Ошибка" 
  }
};



// WEBPACK FOOTER //
// ./src/app/config.ts